import React from 'react';
import clsx from 'clsx';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SegmentedProps<T extends string | number> {
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  label: string;
  disabled?: boolean;
}

/** One choice of a few (design b1 "Speed", "Cut in", d1 "Where", d4 "Size"). */
export function Segmented<T extends string | number>({
  options,
  value,
  onChange,
  label,
  disabled = false,
}: SegmentedProps<T>) {
  return (
    <div className={styles.segmented} role="radiogroup" aria-label={label}>
      {options.map((option) => (
        <button
          key={String(option.value)}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          disabled={disabled}
          className={clsx(styles.segment, option.value === value && styles.segmentOn)}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
